module.exports = {"TXTCLI_Street_Address":{"id":"TXTCLI_Street_Address","defaultMessage":"Street Address","flags":["TRACK"],"track":"Street Address"}}